import { InjectionToken } from '@angular/core';
import { TPayUPosId } from '@simOn/subscription/payment-method/models';

export const PayUConfig = new InjectionToken<TPayUPosId>('PayU config token');
